<template>
  <div class="gridview-wrapper">
    <!-- Toolbar -->
    <div class="gv-toolbar">
      <h2 class="gv-title">{{ this.parentData.pageTitle }}</h2>
      <div class="gv-actions">
        <button class="gv-btn gv-btn-csv" @click="getCSV" title="Export CSV">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <polyline points="9 15 12 18 15 15"/>
          </svg>
          <span>CSV</span>
        </button>
        <button class="gv-btn gv-btn-pdf" @click="getPDF" title="Export PDF">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/>
            <path d="M15 13h1a2 2 0 0 1 0 4h-1"/>
            <line x1="15" y1="17" x2="17" y2="17"/>
          </svg>
          <span>PDF</span>
        </button>
        <button class="gv-btn gv-btn-primary" @click="onNewPressed" title="Add New">
          <v-icon size="16">mdi-plus</v-icon>
          <span>New</span>
        </button>
        <div class="gv-search">
          <v-icon size="18" class="gv-search-icon">mdi-magnify</v-icon>
          <input
            v-model="search"
            type="text"
            placeholder="Search..."
            class="gv-search-input"
          />
        </div>
      </div>
    </div>

    <!-- Table -->
    <v-data-table
      dense
      :headers="formattedHeaders"
      :items="this.parentData.tabItems"
      :search="search"
      :items-per-page="15"
      class="gv-table"
      multi-sort
      fixed-header
    >
      <template v-slot:[`item.action`]="{ item }">
        <div class="gv-row-actions">
          <button v-if="parentData.isAdvanceEdit" class="gv-action-btn gv-action-view" @click="onAdvanceEditItem(item)" title="View">
            <v-icon size="15">mdi-file-document-outline</v-icon>
          </button>
          <button class="gv-action-btn gv-action-edit" @click="onEditItem(item)" title="Edit">
            <v-icon size="15">mdi-pencil</v-icon>
          </button>
          <button v-if="parentData.isDelete" class="gv-action-btn gv-action-delete" @click="onDeleteItem(item)" title="Delete">
            <v-icon size="15">mdi-delete</v-icon>
          </button>
        </div>
      </template>
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
  props: {
    parentData: Object,
    pdfOptions: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      search: "",
    };
  },

  computed: {
    formattedHeaders() {
      if (!this.parentData || !this.parentData.tabHeaders) return [];
      return this.parentData.tabHeaders;
    },
  },

  methods: {
    onAdvanceEditItem(item) {
      this.$emit("AdvanceEditItem", {id: item.id});
    },

    onEditItem(item) {
    //  let search = this.search
      
      this.$emit("EditItem", {id: item.id, search: this.search});
      //this.search = null;
      console.log('search grid', this.search)
     
    },

    onDeleteItem(item) {
      this.$emit("DeleteItem", item);
    },

    onCancelItem(item) {
      this.$emit("CancelItem", item.id, this.search);
    },

    onNewPressed() {
      this.$emit("NewPressed");
    },

    

    objectToCSV(data) {
      const csvRows = [];

      //get header
      const headers = Object.keys(data[0]);
      //const headers = this.titles
      csvRows.push(headers.join(","));

      //loop over the rows
      for (const row of data) {
        const values = headers.map((header) => {
          const escaped = ("" + row[header]).replace(/"/g, '\\"');
          return `"${escaped}"`;
        });
        csvRows.push(values.join(","));
      }
      return csvRows.join("\n");
    },
    download(data) {
      const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", this.parentData.pageTitle + ".csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async getCSV() {
      let titles = this.parentData.tabHeaders;
      let item = this.parentData.tabItems;
      let data = [];
      let obj2 = {};

      titles.forEach((element1) => {
        let x = element1.text;
        obj2[x] = element1.value;
      });

      item.forEach((element1) => {
        let obj = {};
        titles.forEach((element2) => {
          if (element2.value != "action") {
            let key = element2.text;
            obj[key] = element1[element2.value];
          }
        });
        data.push(obj);
      });

      const csvData = this.objectToCSV(data);
      this.download(csvData);
    },

    getPDF() {
      const titles = this.parentData.tabHeaders.filter(h => h.value !== 'action');
      const items  = this.parentData.tabItems;
      const title  = this.parentData.pageTitle || 'Export';

      const opt = this.pdfOptions;
      const fontSize   = opt.fontSize   ?? 9;
      const margin     = opt.margin     ?? { left: 14, right: 14 };
      const startY     = opt.startY     ?? 20;
      const titleSize  = opt.titleSize  ?? 13;
      const titleX     = opt.titleX     ?? 14;
      const titleY     = opt.titleY     ?? 14;

      const doc = new jsPDF({ orientation: 'landscape', format: opt.format ?? 'a4' });

      const head = titles.map(h => ({ title: h.text, dataKey: h.value }));
      const body = items.map(row => {
        const obj = {};
        titles.forEach(h => { obj[h.value] = row[h.value] ?? ''; });
        return obj;
      });

      doc.setFontSize(titleSize);
      doc.text(title, titleX, titleY);
      doc.autoTable({
        columns: head,
        body: body,
        startY,
        margin,
        styles: { fontSize, cellPadding: opt.cellPadding ?? 3, overflow: opt.overflow ?? 'ellipsize' },
        headStyles: { fillColor: [79, 107, 255], textColor: 255, fontSize, fontStyle: 'bold' },
        bodyStyles: { fontSize },
        alternateRowStyles: { fillColor: [248, 250, 255] },
      });
      doc.save(title + '.pdf');
    },

  },

  mounted(){
      this.search = this.parentData.search;
    },
};
</script>

<style scoped>
/* ── Wrapper ── */
.gridview-wrapper {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  border: 1px solid #E8EDF5;
  overflow: hidden;
  font-family: 'Inter', 'Segoe UI', sans-serif;
}

/* ── Toolbar ── */
.gv-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #F8FAFF;
  border-bottom: 1px solid #E8EDF5;
  flex-wrap: wrap;
  gap: 12px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.gv-title {
  font-size: 1rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
}

.gv-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── Buttons ── */
.gv-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  border-radius: 7px;
  border: none;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
}

.gv-btn-csv {
  background: #ECFDF5;
  color: #059669;
  border: 1px solid #A7F3D0;
}
.gv-btn-csv:hover {
  background: #059669;
  color: #fff;
  border-color: #059669;
}

.gv-btn-pdf {
  background: #FEF2F2;
  color: #DC2626;
  border: 1px solid #FECACA;
}
.gv-btn-pdf:hover {
  background: #DC2626;
  color: #fff;
  border-color: #DC2626;
}

.gv-btn-primary {
  background: linear-gradient(135deg, #4F6BFF, #7C3AFF);
  color: #fff;
  box-shadow: 0 4px 12px rgba(79,107,255,0.25);
}
.gv-btn-primary:hover {
  box-shadow: 0 6px 16px rgba(79,107,255,0.35);
  transform: translateY(-1px);
}

/* ── Search ── */
.gv-search {
  position: relative;
  display: flex;
  align-items: center;
}
.gv-search-icon {
  position: absolute;
  left: 10px;
  color: #94A3B8 !important;
  pointer-events: none;
}
.gv-search-input {
  padding: 5px 10px 5px 30px;
  border: 1.5px solid #E8EDF5;
  border-radius: 8px;
  font-size: 0.83rem;
  font-family: inherit;
  color: #1E293B;
  background: #fff;
  outline: none;
  width: 220px;
  transition: border-color 0.15s;
}
.gv-search-input:focus {
  border-color: #4F6BFF;
}
.gv-search-input::placeholder {
  color: #94A3B8;
}

/* ── Row action buttons ── */
.gv-row-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.gv-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: all 0.12s;
  background: transparent;
}
.gv-action-view  { color: #64748B; }
.gv-action-edit  { color: #64748B; }
.gv-action-delete{ color: #64748B; }
.gv-action-view:hover  { background: #EEF2FF; color: #4F6BFF; }
.gv-action-edit:hover  { background: #EEF2FF; color: #4F6BFF; }
.gv-action-delete:hover{ background: #FEE2E2; color: #DC2626; }

/* ── Table overrides ── */
.gv-table {
  border-radius: 0 !important;
  box-shadow: none !important;
  border: none !important;
}
</style>

<style>
/* Global table styles (not scoped so they penetrate v-data-table) */
.gv-table table { background: #fff !important; }
.gv-table thead tr { background: #F8FAFF !important; }
.gv-table thead tr th {
  font-size: 0.65rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.07em !important;
  color: #64748B !important;
  border-bottom: 2px solid #E8EDF5 !important;
  padding: 4px 8px !important;
  white-space: nowrap !important;
}
.gv-table tbody tr { transition: background 0.12s !important; }
.gv-table tbody tr:hover { background: #F5F7FF !important; }
.gv-table tbody tr td {
  font-size: 0.78rem !important;
  color: #334155 !important;
  border-bottom: 1px solid #F1F5F9 !important;
  padding: 0px 8px !important;
  height: 24px !important;
}
.gv-table tbody tr:last-child td { border-bottom: none !important; }
.gv-table.v-data-table--dense tbody tr td { height: 24px !important; }
.gv-table.v-data-table--dense tbody tr { height: 24px !important; }
.gv-table .v-data-table__wrapper { overflow-x: auto; }
.gv-table .v-data-footer {
  background: #F8FAFF !important;
  border-top: 1px solid #E8EDF5 !important;
  font-size: 0.8rem !important;
  color: #64748B !important;
}
</style>